import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ServiceHero from '../../components/services/ServiceHero';
import ServiceContent from '../../components/services/ServiceContent';
import ServiceCTA from '../../components/services/ServiceCTA';

const AISolutions = () => {
  const serviceData = {
    title: 'AI Solutions',
    subtitle: 'Intelligent systems that drive business value',
    description: 'Harness the power of artificial intelligence to automate processes, gain insights, and create competitive advantages. We build custom AI solutions tailored to your specific business needs.',
    sections: [
      {
        heading: 'AI Capabilities We Deliver',
        items: [
          {
            title: 'Machine Learning Models',
            description: 'Custom ML models for prediction, classification, and pattern recognition. We train models on your data to solve specific business problems.',
            icon: 'Brain'
          },
          {
            title: 'Natural Language Processing',
            description: 'Build chatbots, sentiment analysis tools, and text processing systems that understand and generate human language.',
            icon: 'MessageSquare'
          },
          {
            title: 'Computer Vision',
            description: 'Image recognition, object detection, and visual analysis systems for automation and insights.',
            icon: 'Eye'
          },
          {
            title: 'Generative AI',
            description: 'Leverage large language models and generative AI to create content, automate workflows, and enhance user experiences.',
            icon: 'Sparkles'
          }
        ]
      }
    ],
    capabilities: [
      'Custom Machine Learning Models',
      'AI-Powered Chatbots & Virtual Assistants',
      'Predictive Analytics & Forecasting',
      'Natural Language Processing',
      'Computer Vision & Image Recognition',
      'Recommendation Systems',
      'AI Integration with Existing Systems',
      'Data Pipeline & MLOps Setup',
      'AI Strategy Consulting'
    ],
    technologies: ['Python', 'TensorFlow', 'PyTorch', 'OpenAI', 'LangChain', 'Hugging Face', 'scikit-learn', 'FastAPI', 'Docker']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="AI Solutions & Development"
        description="AI-powered products and integrations — machine learning, natural language processing, computer vision, and generative AI solutions for enterprise."
        path="/services/ai-solutions"
      />
      <Header />
      <ServiceHero data={serviceData} />
      <ServiceContent data={serviceData} />
      <ServiceCTA service="AI Solutions" />
      <Footer />
    </div>
  );
};

export default AISolutions;
